<template>
  <div>
    <b-card style="border: none; margin-left: 2rem; margin-right: 2rem">
      <b-row>
        <b-col></b-col>
        <b-col>
          <v-jstree ref="js_tree" :allow-transition="false" style="flex: 1 0"
                    class="my-tree" :data="organisation"
                    @item-click="onItemClicked"
                    show-checkbox></v-jstree>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import VJstree from 'vue-jstree'
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";


export default {
  components: {
    VJstree
  },
  name: "task_step_select_recipient",
  props: ['currentStep', 'isVisible'],
  mounted() {
    this.selectedRecipient = null;

    this.$emit('can-continue', {value: false});
    this.selectedRecipient = this.currentStep.payload.selected_recipient;
    this.showLoader();
    this.$http.get(
        Server_URL+'/auftragsbuch/data/create/step_select_recipient'
    ).then(this.responseOkGet, this.responseError)
  },
  data() {
    return {
      loader: undefined,
      organisation: [],
      selectedRecipient: null,
      selected: null,
    }
  },
  methods: {
    onItemClicked(node, item, e) {
      this.selected = item;
      this.$emit('can-continue', {value: true});
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    getReturnData: function () {
      return {
        selected_recipient: this.selected,
      };
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        let org = response.body;
        this.setNames(org)
        this.organisation = org;
      }else {
        window.location = Redirect_500;
      }
    },
    setNames(org) {
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user') {
          let res = JSON.parse(sessionStorage.getItem(cur.id));
          if (res !== null) {
            org[i].text = res.first_name + " " + res.surname;
          }
        }
        if (cur.children !== null && cur.children.length > 0) {
          org[i].children = this.setNames(cur.children);
        }
      }
      return org
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    setActive: function (payload) {
      if (this.selected !== null) {
        this.$emit('can-continue', {value: true});
      } else {
        this.$emit('can-continue', {value: false});
      }
    },
  }
}
</script>

<style scoped>
.my-tree {
  max-height: calc(70vh - 70px);
  overflow: auto;
}

</style>

<style>
.icon-none {
  display: none !important;
}
</style>
